import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'tr', // Default language
    fallbackLng: 'tr',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      tr: {
        translation: {
          hero: {
            title: "Güvenilir Taşımacılık ve Güvenli Depolama - Hepsi Bir Arada",
            subtitle: "İster şehir içinde taşının ister değerli eşyalarınızı depolayın, uzman ekibimiz eşyalarınızı özenle, hassasiyetle ve gönül rahatlığıyla taşır.",
            button: "Bilgi Al"
          },
          intro: {
            title: "Deneyim, Özveri ve Taşınmanıza Yardımcı Olma Tutkusu",
            desc1: "Huzurlu Taşin evden eve nakliyat ve depolama sigortalı ambalajlı olarak size en iyi hizmetleri sunuyor. Uygun fiyat için doğru yerdesiniz. Ev taşıyor veya eşyalarınızı güvenli bir şekilde saklamak istiyorsanız, ekibimiz sorunsuz ve stressiz bir deneyim sunar.",
            desc2: "Paketlemeden taşımaya, uzun ya da kısa vadeli depolamaya kadar tüm ağır işleri biz üstleniyoruz — böylece siz uğraşmak zorunda kalmazsınız.",
            contactBtn: "Bize Ulaşın"
          },
          offer: {
            title: "Tekliflerimiz",
            subtitle: "Müşterilerimizin büyüme ve başarısına içtenlikle bağlıyız.",
            cards: {
                home: {
                    title: "Evden eve nakliyat",
                    desc: "Profesyonel ve deneyimli ekibimizle müşterilerimize kaliteli hizmet sunmaya çalışıyoruz."
                },
                storage: {
                    title: "Eşya Depolama",
                    desc: "Eşyalarınızı İstanbul'da güvenli bir şekilde depolamak istiyorsanız, depolarımız bir telefon kadar yakın. Eşyalarınızı günlük, haftalık, aylık ya da yıllık olarak özel alanlarda depoluyoruz."
                },
                parts: {
                    title: "Parça Eşya Taşımacılığı",
                    desc: "Hizmetimiz, müşterilerimize güvenilir ve kaliteli hizmet sunma ilkesini benimsemiştir. Firmamız, yılların deneyimiyle müşterilerimizin taşımacılık ihtiyaçlarını karşılayarak memnuniyet sağlar."
                },
                intercity: {
                    title: "Şehirlerarası Nakliyat",
                    desc: "Şehirlerarası evden eve nakliyat firması olarak müşterilerimize güvenilir ve kaliteli taşımacılık hizmeti sunuyoruz."
                },
                international: {
                    title: "Uluslararası Taşımacılık",
                    desc: "Bu hizmetler, uluslararası evden eve taşımacılık, kara, hava ve deniz taşımacılığı, lojistik planlama, gümrükleme, sigorta ve proje yönetimi gibi birçok lojistik çözümü içerir."
                }
            },
            moveTitle: "Taşıyoruz",
            moveDesc: "Ev ve ofis taşımacılığında yılların deneyimiyle her taşımayı titizlikle gerçekleştiriyoruz. Paketlemeden güvenli nakliyeye kadar her adımda eşyalarınız zamanında ve güvenli bir şekilde yerine ulaşır.",
            storeTitle: "Depoluyoruz",
            storeDesc: "Taşınma sürecinizde ekstra alana mı ihtiyacınız var? Temiz ve güvenli depolarımız kısa ve uzun süreli çözümler sunar. Mobilyadan kutulara kadar değerli eşyalarınız için güvenli alanımız var."
        },
        services: {
            title: "Huzurlu Taşin evden eve nakliye hizmetlerimiz",
            cards: {
                relocation: {
                    title: "Ev Taşıma Hizmetleri",
                    desc: "İhtiyaçlarınıza özel sorunsuz ve stressiz ev taşıma hizmetleri sunuyoruz. Şehir içinde ya da şehirler arası taşıma fark etmeksizin, profesyonel ekibimiz eşyalarınızın güvenli ve verimli bir şekilde taşınmasını sağlar.",
                    button: "Taşıma Planla"
                },
                office: {
                    title: "Ofis ve Ticari Taşımacılık",
                    desc: "Kesinti ve aksaklıkları en aza indiren ofis taşıma çözümlerimizle işinize odaklanın. Paketlemeden etiketlemeye, yeni iş yerinizin kurulumuna kadar her şeyi biz hallediyoruz.",
                    button: "Ticari Taşıma Rezervasyonu"
                },
                storage: {
                    title: "Güvenli Depolama Çözümleri",
                    desc: "Eşyalarınızı depolamak mı istiyorsunuz? Kısa veya uzun süreli ihtiyaçlarınız için güvenli, iklim kontrollü depolama alanları sunuyoruz. Evinizi düzenlemek, tadilat yapmak ya da geçici taşınmalarda idealdir.",
                    button: "Depo Ayırt"
                },
                elevator: {
                    title: "Asansör Hizmeti",
                    desc: "Asansör hizmetimiz yüksek katlı binalarda ağır mobilya ve eşyaların güvenli taşınmasını sağlar. Üst katlara taşınırken veya taşınırken, özel sistemlerimiz ve eğitimli ekibimizle hasarı önleyerek zaman kazandırır.",
                    button: "Asansör Hizmeti Ekle"
                }
            }
        },
        footer: {
            title: "Bize Ulaşın",
            desc: "Her türlü taşıma ve depolama ihtiyacınız için bizimle iletişime geçin. Size yardımcı olmaktan memnuniyet duyarız.",
            name: "Adınız",
            lastName: "Soyadınız",
            email: "E-posta",
            phone: "Telefon numarası",
            office_address: "Ofis Adresi",
            message: "Mesajınız",
            button: "Gönder",
            call_us: "Bizi Arayın",
            email_us: "E-posta Gönder",
            location: "Konumumuz",
            rights: " Huzurlu Taşin. Tüm hakları saklıdır."
        },
        orderproduct: {
            title: "Ürünlerimizi sipariş edin",
            checkbox1: "Ev Taşıma Hizmetleri",
            checkbox2: "Ofis ve Ticari Taşımacılık",
            checkbox3: "Güvenli Depolama Çözümleri",
            checkbox4: "Asansör Hizmeti",
        },
        navbar: {
            about: "Hakkımızda",
            offer: "Tekliflerimiz",
            services: "Hizmetlerimiz",
            contact: "İletişim",
            order: "Ürünlerimizi sipariş edin"
        },
        form: {
            "success": "Başarılı",
            "ok": "Tamam",
            "send_message": "Mesaj Gönder",
            "contact_success_message": "Mesajınız başarıyla gönderildi!",
            "error_occurred": "Bir hata oluştu",
            "server_error_message": "Mesajınızı gönderemedik. Lütfen daha sonra tekrar deneyin."
        },
    }
},
      en: {
        translation: {
          hero: {
            title: "Reliable Moving & Secure Storage - All in One Place",
            subtitle: "Whether you're relocating across town or storing valuables for the future, our expert team ensures your belongings are handled with care, precision, and peace of mind.",
            button: "Get Information"
          },
          intro: {
            title: "Experience, Dedication, and a Passion for Helping You Move",
            desc1: "Kurtköy Dinçer offers the best home-to-home moving and storage services, including insured and packaged goods. You're in the right place for affordable prices. Whether you're relocating your home or need a safe space to store your belongings, our dedicated team ensures a smooth, stress-free experience from start to finish.",
            desc2: "From packing and transport to long- or short-term storage, we take care of the heavy lifting — so you don’t have to.",
            contactBtn: "Contact us"
          },
        offer: {
            title: "What we offer",
            subtitle: "We are deeply committed to the growth and success of our clients.",
            cards: {
                home: {
                    title: "Home to home transport",
                    desc: "We strive to provide quality service to our customers with our professional and experienced team."
                },
                storage: {
                    title: "Goods Storage",
                    desc: "If you are looking for a safe place to store your belongings in Istanbul, our storage is as close to you as a phone. We store your belongings daily, weekly, monthly, or annually in special areas."
                },
                parts: {
                    title: "Parts Transportation",
                    desc: "Our service is committed to providing reliable and high-quality service to our customers. Our company ensures customer satisfaction through years of experience and expertise."
                },
                intercity: {
                    title: "Intercity Transportation",
                    desc: "As an intercity home-to-home transport company, we aim to provide reliable and high-quality services to our customers."
                },
                international: {
                    title: "International Transportation",
                    desc: "These services include international home-to-home transport, land, air, and sea transport, logistics planning, customs clearance, insurance, and project management."
                }
            },
            moveTitle: "We Move",
            moveDesc: "With years of experience in residential and commercial relocations, we handle every move with care and precision. From packing and loading to safe transport, our team ensures your belongings arrive securely and on time — wherever life takes you.",
            storeTitle: "We Store",
            storeDesc: "Need extra space during your transition? Our clean, secure storage facilities offer short- and long-term solutions to keep your items protected. Whether it’s furniture, boxes, or valuables, we’ve got room for what matters most to you."
        },
        services: {
            title: "Our Services",
            cards: {
                relocation: {
                    title: "Home Relocation Services",
                    desc: "We offer seamless and stress-free home relocation services tailored to meet your needs. Whether you're moving across town or to a different city, our professional team ensures your belongings are transported safely and efficiently.",
                    button: "Schedule Move"
                },
                office: {
                    title: "Office & Commercial Moves",
                    desc: "Minimize downtime and disruption with our expert office relocation solutions. We handle everything from packing and labeling to setting up your new workspace, so you can focus on your business.",
                    button: "Book Commercial Move"
                },
                storage: {
                    title: "Secure Storage Solutions",
                    desc: "Need a place to store your items? We provide secure, climate-controlled storage units for short-term or long-term needs. Ideal for decluttering, renovating, or temporary moves.",
                    button: "Reserve Storage Unit"
                },
                elevator: {
                    title: "Elevator Service",
                    desc: "Elevator Service ensures the safe and efficient transport of heavy furniture and appliances from high-rise buildings. Whether you're moving in or out of an upper-floor apartment, our specialized elevator systems and trained team minimize effort, prevent damage, and save valuable time.",
                    button: "Add Elevator Service"
                }
            }
        },
        footer: {
            title: "Contact Us",
            desc: "Reach out to us for any moving and storage needs. We're here to help.",
            name: "Your Name",
            lastName: "Your Last Name",
            email: "Email",
            phone: "Phone number",
            message: "Your Message",
            button: "Send",
            office_address: "Office Address",
            call_us: "Call Us",
            email_us: "Email Us",
            location: "Our Location",
            rights: "Huzurlu Taşin. All rights reserved."
        },
        orderproduct: {
            title: "Order Our Products",
            checkbox1: "Home Relocation Services",
            checkbox2: "Office & Commercial Moves",
            checkbox3: "Secure Storage Solutions",
            checkbox4: "Elevator Service"
        },
        navbar: {
            about: "About Us",
            offer: "We Offer",
            services: "Services",
            contact: "Contact Us",
            order: "Order Our Products"
        },
        form: {
            "success": "Success",
            "ok": "Okay",
            "send_message": "Send Message",
            "contact_success_message": "Your message has been sent successfully!",
            "error_occurred": "An error occurred",
            "server_error_message": "We couldn't send your message. Please try again later."
        },
        email: {
            greeting: "You received a new message from a user:",
            name: "Name",
            email: "Email",
            phone: "Phone",
            message: "Message"
        },
    }
},
      ru: {
        translation: {
          hero: {
            title: "Надёжный переезд и безопасное хранение — всё в одном месте",
            subtitle: "Переезжаете ли вы по городу или храните ценные вещи, наша команда обеспечивает заботу, точность и спокойствие за ваши вещи.",
            button: "Получить информацию"
          },
          intro: {
            title: "Опыт, преданность и стремление помочь вам переехать",
            desc1: "Компания Kurtköy Dinçer предлагает лучшие услуги по переезду и хранению вещей, включая страховку и упаковку. Вы обратились по адресу по доступным ценам. Переезжаете или нуждаетесь в безопасном месте для хранения вещей — наша команда обеспечит вам спокойствие и комфорт.",
            desc2: "От упаковки и перевозки до долгосрочного или краткосрочного хранения — мы берём всё на себя, чтобы вам не пришлось.",
            contactBtn: "Связаться с нами"
          },
          offer: {
            title: "Что мы предлагаем",
            subtitle: "Мы глубоко привержены росту и успеху наших клиентов.",
            cards: {
            home: {
                title: "Квартирный переезд",
                desc: "Мы стремимся предоставить нашим клиентам качественное обслуживание с профессиональной и опытной командой."
            },
            storage: {
                title: "Хранение вещей",
                desc: "Если вы ищете безопасное место для хранения ваших вещей в Стамбуле, наши склады всего в одном звонке от вас. Мы храним вещи на день, неделю, месяц или год в специальных зонах."
            },
            parts: {
                title: "Перевозка отдельных предметов",
                desc: "Наша служба придерживается принципа надежности и качества обслуживания. Мы обеспечиваем удовлетворенность клиентов благодаря опыту и профессионализму."
            },
            intercity: {
                title: "Междугородний переезд",
                desc: "Как компания, специализирующаяся на междугородних переездах, мы предоставляем надежные и качественные услуги нашим клиентам."
            },
            international: {
                title: "Международная перевозка",
                desc: "Наши услуги включают международные квартирные переезды, перевозки по суше, воздуху и морю, логистику, таможенное оформление, страхование и управление проектами."
            }
            },
            moveTitle: "Мы переезжаем",
            moveDesc: "С годами опыта в жилищных и коммерческих переездах мы обеспечиваем аккуратную и точную транспортировку. От упаковки до доставки — ваши вещи приедут вовремя и в безопасности.",
            storeTitle: "Мы храним",
            storeDesc: "Нужен дополнительный склад на время переезда? Наши чистые и безопасные склады обеспечивают кратко- и долгосрочное хранение. Мебель, коробки или ценные вещи — у нас найдется место для всего важного."
          },
          services: {
            title: "Наши Услуги",
            cards: {
                relocation: {
                    title: "Услуги по Переезду",
                    desc: "Мы предлагаем удобные и беззаботные услуги по переезду, адаптированные под ваши потребности. Независимо от того, переезжаете ли вы в пределах города или в другой город, наша профессиональная команда обеспечит безопасную и быструю транспортировку ваших вещей.",
                    button: "Запланировать Переезд"
                },
                office: {
                    title: "Офисные и Коммерческие Переезды",
                    desc: "Минимизируйте простой и сбои с помощью наших решений по переезду офисов. Мы берем на себя упаковку, маркировку и установку на новом месте, чтобы вы могли сосредоточиться на бизнесе.",
                    button: "Заказать Коммерческий Переезд"
                },
                storage: {
                    title: "Надёжные Складские Решения",
                    desc: "Нужен склад? Мы предоставляем безопасные, с климат-контролем складские помещения для краткосрочного или долгосрочного хранения. Отлично подходит для временного хранения, ремонта или освобождения места.",
                    button: "Забронировать Склад"
                },
                elevator: {
                    title: "Услуги Лифта",
                    desc: "Лифтовый сервис обеспечивает безопасную и эффективную транспортировку крупной мебели и техники в многоэтажных зданиях. Это отличное решение для громоздких предметов, особенно если нет грузового лифта.",
                    button: "Добавить лифтовый сервис"
                }
            }
        },
        footer: {
            title: "Связаться с нами",
            desc: "Свяжитесь с нами по любым вопросам переезда и хранения. Мы всегда готовы помочь.",
            name: "Ваше имя",
            lastName: "Ваша фамилия",
            phone: "Телефон номер",
            email: "Электронная почта",
            message: "Ваше сообщение",
            button: "Отправить",
            office_address: "Адрес офиса",
            call_us: "Позвоните нам",
            email_us: "Напишите нам",
            location: "Наш адрес",
            rights: "2025 Huzurlu Taşin. Все права защищены."
        },
        orderproduct: {
            title: "Закажите наши продукты",
            checkbox1: "Услуги по Переезду",
            checkbox2: "Офисные и Коммерческие Переезды",
            checkbox3: "Надёжные Складские Решения",
            checkbox4: "Услуги Лифта",
        },
        navbar: {
            about: "О нас",
            offer: "Наши предложения",
            services: "Наши услуги",
            contact: "Контакты",
            order: "Заказать наши продукты"
        },
        form: {
            "success": "Успех",
            "ok": "ОК",
            "send_message": "Отправить сообщение",
            "contact_success_message": "Ваше сообщение успешно отправлено!",
            "error_occurred": "Произошла ошибка",
            "server_error_message": "Не удалось отправить ваше сообщение. Пожалуйста, попробуйте позже."
        },
        email: {
            greeting: "Вы получили новое сообщение от пользователь:",
            name: "Имя",
            email: "Электронная почта",
            phone: "Телефон",
            message: "Сообщение"
        },
    }
}
}
  });

export default i18n;
